<navigation-dropdown class="mt-18px" [menuItems]="contextMenuItems" [dropdownTitle]="'open_dropdown_content' | localize" (dropdownToggled)="onMenuToggled($event)" dropdownMenuClass="l--14px">
  <div class="context-menu-btn gh-font-icon-menu p-7px fs-14px ink-10-v3 h-28px w-28px" *ngIf="contextMenuItems.length" gh-dropdown-toggle></div>
</navigation-dropdown>
